import process from "node:process";
import type { AppMeta } from "@calcom/types/App";

export const metadata = {
  name: "Cal Video",
  description:
    "Cal Video is the in-house web-based video conferencing platform powered by Daily.co, which is minimalistic and lightweight, but has most of the features you need.",
  // LIXIL audit (2026-05-15): Daily.co disabled by default for lixil-meet.
  // LIXIL uses Zoom (see packages/app-store/zoomvideo). To re-enable Daily, set DAILY_API_KEY AND LIXIL_MEET_ENABLE_DAILY=true.
  installed: !!process.env.DAILY_API_KEY && process.env.LIXIL_MEET_ENABLE_DAILY === "true",
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Cal.diy",
  category: "conferencing",
  slug: "daily-video",
  title: "Cal Video",
  isGlobal: true,
  email: "support@hellomatik.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Cal Video",
    },
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: false,
} as AppMeta;

export default metadata;
